import axios from "axios";
import Cookies from "js-cookie";
import { createStandaloneToast } from "@chakra-ui/react";

import {
  DELETE_BRANCH_DATA_SUCCESS,
  DELETE_CITY_DATA_SUCCESS,
  DELETE_WHATSIMAGE_DATA_SUCCESS,
  DELETE_COURSE_DATA_SUCCESS,
  DELETE_DATA_FAILURE,
  DELETE_DATA_REQUEST,
  DELETE_LEAD_DATA_SUCCESS,
  DELETE_SOURCE_DATA_SUCCESS,
  DELETE_STATUS_DATA_SUCCESS,
  DELETE_USER_DATA_SUCCESS,
  DELETE_ADMIN_DATA_SUCCESS,
  GET_BRANCH_DATA_SUCCESS,
  GET_CITY_DATA_SUCCESS,
  GET_WHATSIMAGE_DATA_SUCCESS,
  GET_CONTACT_DATA_SUCCESS,
  GET_COURSE_ANALYTICS_SUCCESS,
  GET_COURSE_DATA_SUCCESS,
  GET_DATA_FAILURE,
  GET_DATA_REQUEST,
  GET_LEAD_COUNT_SUCCESS,
  GET_LEAD_DATA_SUCCESS,
  GET_SINGLE_BRANCH_DATA_SUCCESS,
  GET_SINGLE_CITY_DATA_SUCCESS,
  GET_SINGLE_CONTACT_DATA_SUCCESS,
  GET_SINGLE_COURSE_DATA_SUCCESS,
  GET_SINGLE_DATA_FAILURE,
  GET_SINGLE_DATA_REQUEST,
  GET_SINGLE_LEAD_DATA_SUCCESS,
  GET_SINGLE_SOURCE_DATA_SUCCESS,
  GET_SINGLE_STATUS_DATA_SUCCESS,
  GET_SINGLE_USER_DATA_SUCCESS,
  GET_SUPER_SINGLE_PARTICULAR_ADMIN_REVENUE,
  GET_SINGLE_ADMIN_DATA_SUCCESS,
  GET_SOURCE_ANALYTICS_SUCCESS,
  GET_SOURCE_DATA_SUCCESS,
  GET_STATUS_DATA_SUCCESS,
  GET_USER_DATA_SUCCESS,
  GET_SUPPORT_DATA_SUCCESS,
  GET_ADMIN_DATA_SUCCESS,
  POST_BRANCH_DATA_SUCCESS,
  POST_CITY_DATA_SUCCESS,
  POST_WHATSIMAGE_DATA_SUCCESS,
  POST_COURSE_DATA_SUCCESS,
  POST_DATA_FAILURE,
  POST_DATA_REQUEST,
  POST_LEAD_DATA_SUCCESS,
  POST_LEAD_ASSIGN_SUCCESS,
  POST_LEAD_LOGS_SUCCESS,
  POST_SIGN_IN_SUCCESS,
  POST_SIGN_OUT_SUCCESS,
  POST_SOURCE_DATA_SUCCESS,
  POST_STATUS_DATA_SUCCESS,
  POST_USER_DATA_SUCCESS,
  POST_SUPPORT_DATA_SUCCESS,
  POST_ADMIN_DATA_SUCCESS,
  UPDATE_BRANCH_DATA_SUCCESS,
  UPDATE_CITY_DATA_SUCCESS,
  UPDATE_WHATSIMAGE_DATA_SUCCESS,
  UPDATE_COURSE_DATA_SUCCESS,
  UPDATE_DATA_FAILURE,
  UPDATE_DATA_REQUEST,
  UPDATE_LEAD_DATA_SUCCESS,
  UPDATE_SOURCE_DATA_SUCCESS,
  UPDATE_STATUS_DATA_SUCCESS,
  UPDATE_USER_DATA_SUCCESS,
  UPDATE_ADMIN_DATA_SUCCESS,
  GET_SINGLE_WHATSIMAGE_DATA_SUCCESS,
  GET_SINGLE_SUPER_SIDEMENU,
  GET_SINGLE_SUPER_TODO,
  GET_SUPER_ADMIN_REVENUE,
  GET_SUPER_DASHBOARD_TILES,
  GET_SUPER_SIDEMENU,
  GET_SUPER_TODO,
  POST_SUPER_SIDEMENU,
  POST_TODO_DATA,
  UPDATE_SUPER_SIDEMENU,
  UPDATE_SUPER_TODO,
  DELETE_SUPER_SIDEMENU,
  DELETE_TODO_DATA,
  POST_SIGN_UP_SUCCESS,
  GET_SINGLE_SUPPORT_DATA_SUCCESS,
  UPDATE_SUPPORT_DATA_SUCCESS,
  POST_FORGET_PASSWORD_REQUEST,
  POST_FORGET_PASSWORD_SUCCESS,
  POST_PROPOSAL_SUCCESS,
  GET_PROPOSAL_DATA,
  GET_SINGLE_PROPOSAL,
  UPDATE_PROPOSAL_DATA,
  GET_PROPOSAL_GREETING_DATA,
  UPDATE_PROPOSAL_GREETING_DATA,
  GET_SINGLE_PROPOSAL_GREETING,
  POST_GREETING_CATEGORY_SUCCESS,
  GET_GREETING_CATEGORY_DATA,
  DELETE_GREETING_SUCCESS,
  POST_CLIENT_PROPOSAL_EMAIL,
  POST_CATEGORY_SUCCESS,
  POST_EMAIL_TEMPLATE_DATA_SUCCESS,
  GET_EMAIL_TEPLATES_SUCCESS,
  UPDATE_EMAIL_TEMPLATE_DATA,
  DELETE_EMAIL_TEMPLATE_SUCCESS,
  POST_BULK_EMAIL_SEND_DATA_SUCCESS,
  POST_EMAIL_TEMPLATE_CATEGORY_SUCCESS,
  GET_EMAIL_TEMPLATE_CATOGORY_SUCCESS,
  POST_IMAGE_CLOUDINARY_SUCCESS,
  POST_COVER_IMAGE_EMAIL_SUCCESS,
  GET_EMAIL_CAMPAIGN_REPORT,
  POST_WHATSAPP_TEMPLATE_SUCCESS,
  GET_WHATSAPP_TEMPLATE_SUCCESS,
  UPDATE_WHATSAPP_TEMPLATE_DATA,
  DELETE_WHATSAPP_TEMPLATE_SUCCESS,
  POST_SMS_TEMPLATE_SUCCESS,
  GET_SMS_TEMPLATE_SUCCESS,
  UPDATE_SMS_TEMPLATE_DATA,
  DELETE_SMS_TEMPLATE_SUCCESS,
  GET_DEMO_ENQUIRY_SUCCESS,
  UPDATE_DEMO_ENQUIRY_DATA_SUCCESS,
  GET_SINLGE_DEMO_EMQUIRY_DATA_SUCCESS,
  POST_SUPER_USER_DATA_SUCCESS,
  GET_SUPER_USER_DATA_SUCCESS,
  UPDATE_SUPER_USER_DATA_SUCCESS,
  GET_SUPER_GREETING_CATEGORIES_SUCCESS,
  GET_SUPER_PROPOSAL_GREETING_SUCCESS,
  UPDATE_SUPER_PROPOSAL_GREETING_SUCCESS,
  POST_SUPER_BRANCH_SUCCESS,
  GET_SUPER_BRANCH_DATA_SUCCESS,
  UPDATE_SUPER_BRANCH_DATA_SUCCESS,
  POST_SUPER_CITY_DATA_SUCCESS,
  GET_SUPER_CITY_DATA_SUCCESS,
  UPDATE_SUPER_CITY_DATA_SUCCESS,
  POST_SUPER_EMAIL_TEMPLATE_CATEGORY_SUCCESS,
  GET_SUPER_EMAIL_TEMPLATE_CATOGORY_SUCCESS,
  POST_SUPER_EMAIL_TEMPLATE_DATA_SUCCESS,
  GET_SUPER_EMAIL_TEMPLATES_SUCCESS,
  UPDATE_SUPER_EMAIL_TEMPLATE_DATA,
  POST_DEMO_ENQUIRY_DATA_SUCCESS,
  DELETE_PROPOSAL_SUCCESS,
  POST_NAVBAR_CONTENT_SUCCESS,
  GET_NAVBAR_CONTENT_SUCCESS,
  GET_SINGLE_NAVBAR_CONTENT_SUCCESS,
  UPDATE_NAVBAR_CONTENT_SUCCESS,
  DELETE_NAVBAR_CONTENT_SUCCESS,
  POST_LEGAL_CONTENT_SUCCESS,
  GET_LEGAL_CONTENT_SUCCESS,
  GET_PUBLIC_LEGAL_CONTENT_SUCCESS,
  GET_SINGLE_LEGAL_CONTENT_SUCCESS,
  DELETE_LEGAL_CONTENT_SUCCESS,
  UPDATE_LEGAL_CONTENT_SUCCESS,
  POST_CONTACT_ENQUIRY_SUCCESS,
  GET_CONTACT_ENQUIRY_SUCCESS,
  GET_SINGLE_CONTACT_ENQUIRY_SUCCESS,
  DELETE_CONTACT_ENQUIRY_SUCCESS,
  UPDATE_CONTACT_ENQUIRY_SUCCESS,
  POSTFOOTERCONTENTSUCCESS,
  GETFOOTERCONTENTSUCCESS,
  GETSINGLEFOOTERCONTENTSUCCESS,
  DELETEFOOTERCONTENTSUCCESS,
  UPDATEFOOTERCONTENTSUCCESS,
  GET_PROPOSAL_SUMMARY_SUCCESS,
  POST_PROPOSAL_TERMS_SUCCESS,
  POST_TERMS_CATEGORY_SUCCESS,
  GET_PROPOSAL_TERMS_DATA,
  GET_TERMS_CATEGORY_DATA,
  GET_SUPER_TERMS_CATEGORIES_SUCCESS,
  GET_SUPER_PROPOSAL_TERMS_SUCCESS,
  GET_SINGLE_PROPOSAL_TERMS,
  DELETE_TERMS_SUCCESS,
  UPDATE_PROPOSAL_TERMS_DATA,
  UPDATE_SUPER_PROPOSAL_TERMS_SUCCESS,
  MARK_PROPOSAL_AS_SENT_SUCCESS,
  CANCEL_PROPOSAL_SUCCESS,
  GET_LEAD_SUMMARY_SUCCESS,
  SEND_PAYMENT_REMAINDER_MAIL,
  GET_PAYMENT_DETAILS_SUCCESS,
  UPDATE_PROPOSAL_PAYMENT_MODE_SUCCESS,
  POST_LEAD_FIELD_CONFIG_SUCCESS,
  GET_LEAD_FIELD_CONFIG_SUCCESS,
  POST_ACCOUNT_DATA_SUCCESS,
  GET_ACCOUNT_DATA_SUCCESS,
  DELETE_ACCOUNT_DATA_SUCCESS,
  UPDATE_ACCOUNT_DATA_SUCCESS,
  POST_ADMISSION_DATA_SUCCESS,
  GET_ADMISSION_DATA_SUCCESS,
  DELETE_ADMISSION_DATA_SUCCESS,
  UPDATE_ADMISSION_DATA_SUCCESS,
  SEND_ADMISSION_PAYMENT_REMAINDER_MAIL,
  UPDATE_ADMISSION_PAYMENT_MODE_SUCCESS,
  UPDATE_MANUAL_PAYMENT_SUCCESS,
  GET_SINGLE_ADMISSION_DATA_SUCCESS,
  SET_SIGNIN_USER,
} from "../types/common.types";
import { BASE_URL, BASE_URL_SUPERADMIN } from "../../config/RequestMethod";
import { useToast } from "@chakra-ui/react";

const { toast } = createStandaloneToast();

export const autoLogout = () => async (dispatch) => {
  try {
    const token = Cookies.get("token");

    if (token) {
      // Try to notify backend about logout (optional, may fail if token expired)
      try {
        await axios.post(
          `${BASE_URL}auth/signout`,
          { type: "web" },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      } catch (error) {
        // Ignore errors from backend, we're logging out anyway
        console.log(
          "Backend signout failed (expected if token expired):",
          error,
        );
      }
    }

    // Clear all auth data
    Cookies.remove("token");

    // Dispatch logout action
    dispatch({ type: POST_SIGN_OUT_SUCCESS });

    // Set logout message
    Cookies.set(
      "logoutMessage",
      "Your session has expired. Please login again.",
      {
        path: "/",
        secure: false,
      },
    );

    // Redirect to login
    window.location.href = "/login";
  } catch (error) {
    console.error("Auto logout error:", error);
    // Force cleanup even if there's an error
    Cookies.remove("token");
    dispatch({ type: POST_SIGN_OUT_SUCCESS });
    window.location.href = "/login";
  }
};

export const setSigninUser = (userPatch) => (dispatch) => {
  dispatch({ type: SET_SIGNIN_USER, payload: userPatch });
};

//navigate routes common for navigation
const endpointRoutes = {
  sidemenu: "/sidemenu",
  // todo: "/admin-dashboard",
  adminRevenue: "/adminrevenue",
  supertiles: "/supertiles",
  particularAdmin: "/particularAdmin",
  course: "/product-list",
  branch: "/branch-list",
  superBranches: "/branch-list",
  superBranch: "/branch-list",
  source: "/source-list",
  city: "/city-list",
  superCity: "/city-list",
  proposal: "/proposal-list",
  contact: "/contact-list",
  status: "/status-list",
  user: "/user-list",
  "": "/admin-list",
  lead: "/lead-list",
  proposal: "/proposal-list",
  assignlead: "lead/assign-to-user",
  template: "/template",
  "/auth/forgot-password": "login",
  emailTemplate: "/create-template-email",
  superEmailTemplate: "/create-template-email",
  whatsAppTemplate: "/create-template-whatsApp",
  proposalGreeting: "/proposal-greeting",
  superProposalGreeting: "/proposal-greeting",
  "navbar-content": "/navbar-content-list",
  "legal-content": "/legal-content-list",
  "contact-enquiry": "/contact-enquiry-list",
  "footer-content": "/footer-content-list",
  proposalTerms: "/proposal-terms",
  superProposalTerms: "/proposal-terms",
  account: "/account-list",
  admission: "/admission-list",
};

//POST DATA
//these are POSTendpointActionTypesPost for the Types of the redux
//if the endpoint is coming course then it will trigger the TYPE e.g.  POST_COURSE_DATA_SUCCESS,

const POSTendpointActionTypesPost = {
  course: POST_COURSE_DATA_SUCCESS,
  branch: POST_BRANCH_DATA_SUCCESS,
  superBranch: POST_SUPER_BRANCH_SUCCESS,
  source: POST_SOURCE_DATA_SUCCESS,
  city: POST_CITY_DATA_SUCCESS,
  superCity: POST_SUPER_CITY_DATA_SUCCESS,
  template: POST_WHATSIMAGE_DATA_SUCCESS,
  status: POST_STATUS_DATA_SUCCESS,
  user: POST_USER_DATA_SUCCESS,
  issue: POST_SUPPORT_DATA_SUCCESS,
  admin: POST_ADMIN_DATA_SUCCESS,
  lead: POST_LEAD_DATA_SUCCESS,
  assignlead: POST_LEAD_ASSIGN_SUCCESS,
  sidemenu: POST_SUPER_SIDEMENU,
  todo: POST_TODO_DATA,
  proposal: POST_PROPOSAL_SUCCESS,
  proposalGreeting: POST_GREETING_CATEGORY_SUCCESS,
  greetingCategory: POST_CATEGORY_SUCCESS,
  "client-proposal": POST_CLIENT_PROPOSAL_EMAIL,
  // "admins/todo": POST_SUPER_TODO,
  "lead/logs": POST_LEAD_LOGS_SUCCESS,
  "auth/signin": POST_SIGN_IN_SUCCESS,
  "auth/signup": POST_SIGN_UP_SUCCESS,
  "auth/signout": POST_SIGN_OUT_SUCCESS,
  "auth/request-forgot-password": POST_FORGET_PASSWORD_REQUEST,
  "/auth/forgot-password": POST_FORGET_PASSWORD_SUCCESS,
  "upload-image": POST_IMAGE_CLOUDINARY_SUCCESS,

  emailTemplate: POST_EMAIL_TEMPLATE_DATA_SUCCESS,
  superEmailTemplate: POST_SUPER_EMAIL_TEMPLATE_DATA_SUCCESS,
  emailTemplateCategory: POST_EMAIL_TEMPLATE_CATEGORY_SUCCESS,
  superEmailTemplateCategory: POST_SUPER_EMAIL_TEMPLATE_CATEGORY_SUCCESS,
  "client-proposal/bulk-send-email": POST_BULK_EMAIL_SEND_DATA_SUCCESS,
  emailCoverImage: POST_COVER_IMAGE_EMAIL_SUCCESS,
  whatsAppTemplate: POST_WHATSAPP_TEMPLATE_SUCCESS,
  smsTemplate: POST_SMS_TEMPLATE_SUCCESS,
  addSuperUser: POST_SUPER_USER_DATA_SUCCESS,
  "demo-user": POST_DEMO_ENQUIRY_DATA_SUCCESS,
  "navbar-content": POST_NAVBAR_CONTENT_SUCCESS,
  "legal-content": POST_LEGAL_CONTENT_SUCCESS,
  "contact-enquiry": POST_CONTACT_ENQUIRY_SUCCESS,
  "footer-content": POSTFOOTERCONTENTSUCCESS,
  proposalTerms: POST_PROPOSAL_TERMS_SUCCESS,
  termsCategory: POST_TERMS_CATEGORY_SUCCESS,
  "lead-field-config": POST_LEAD_FIELD_CONFIG_SUCCESS,
  account: POST_ACCOUNT_DATA_SUCCESS,
  admission: POST_ADMISSION_DATA_SUCCESS,
};

//common function for postdata
//it took parameter as  formData, endpoint, navigate and toast

export const postData =
  (formData, endpoint, navigate, toast) => async (dispatch) => {
    // Get the success action type based on the endpoint
    let successActionTypePost = POSTendpointActionTypesPost[endpoint];

    if (!successActionTypePost) {
      toast({
        title: `Invalid endpoint: "${endpoint}"`,
        description:
          "Please contact the developer to add the correct action type.",
        status: "error",
        position: "top-right",
        isClosable: true,
      });

      console.error(`❌ No action type mapped for endpoint "${endpoint}"`);
      return; // 🛑 Stop further execution
    }

    dispatch({ type: POST_DATA_REQUEST }); // Dispatch a request action
    try {
      console.log("Posting to:", endpoint, "with data:", formData);
      const token = Cookies.get("token");
      // Get the token from the cookie
      const res = await axios.post(
        `${BASE_URL}${endpoint}`, // Make a POST request to the specified endpoint
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the headers
          },
        },
      );
      console.log(res.data, "ok");

      // Check the role of the user and navigate accordingly
      if (res.data.userData?.UserType === 3) {
        navigate("/");
      }
      if (res.data.userData?.UserType === 2) {
        navigate("/admin-dashboard");
        console.log("admin");
      }
      if (res.data.userData?.UserType === 1) {
        navigate("/super-dashboard");
      }

      dispatch({ type: successActionTypePost, payload: res.data }); // Dispatch the success action with the response data
      console.log(res.data.message, "alert");
      // Display a success toast notification

      const message = res.data?.message || "Operation successful.";
      toast({
        title: message,
        status: "success",
        position: "top-right",
        isClosable: true,
      });

      if (res.data?.token) {
        console.log(res.data.token, "tokennnnn");
        Cookies.set("token", res.data.token, {
          expires: 7,
          path: "/", // Ensure path is root
          secure: true,
          sameSite: "none",
        });
        console.log(Cookies.get("token"));
        // Store the new token as a cookie that expires in 7 days
      }
      if (endpoint in endpointRoutes) {
        navigate(endpointRoutes[endpoint]); // Navigate based on the endpoint route
      }

      return res.data;
    } catch (error) {
      dispatch({ type: POST_DATA_FAILURE, payload: error.message }); // Dispatch a failure action with the error message
      console.log("hi");
      // Display an error toast notification with the error message
      toast({
        title: `${error.response?.data.message}`,
        status: "error",
        position: "top-right",
        isClosable: true,
      });

      console.log(error.message);
    }
  };

export const postDataSuperAdmin =
  (formData, endpoint, navigate, toast) => async (dispatch) => {
    // Get the success action type based on the endpoint
    let successActionTypePost = POSTendpointActionTypesPost[endpoint];
    dispatch({ type: POST_DATA_REQUEST }); // Dispatch a request action
    try {
      const token = Cookies.get("token");
      // Get the token from the cookie
      const res = await axios.post(
        `${BASE_URL_SUPERADMIN}${endpoint}`, // Make a POST request to the specified endpoint
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the headers
          },
        },
      );
      console.log("hi");
      console.log(res.data.userData, "okusr");

      dispatch({ type: successActionTypePost, payload: res.data }); // Dispatch the success action with the response data
      console.log(res.data.message, "alert");
      // Display a success toast notification
      toast({
        title: `${res.data.message}`,
        status: "success",
        position: "top-right",
        isClosable: true,
      });

      if (res.data?.token) {
        Cookies.set("token", res.data.token, { expires: 7 });
        // Store the new token as a cookie that expires in 7 days
      }

      if (endpoint in endpointRoutes) {
        navigate(endpointRoutes[endpoint]); // Navigate based on the endpoint route
      }

      return res.data;
    } catch (error) {
      dispatch({ type: POST_DATA_FAILURE, payload: error.message }); // Dispatch a failure action with the error message
      console.log("error");
      // Display an error toast notification with the error message
      toast({
        title: `${error.response?.data.message}`,
        status: "error",
        position: "top-right",
        isClosable: true,
      });

      console.log(error.message);
    }
  };

//GET DATA
//these are GETendpointActionTypes for the Types of the redux
//if the endpoint is coming course then it will trigger the TYPE e.g.  GET_COURSE_DATA_SUCCESS,
//endpoint are coming  from the parameter of the function and its triggering the action accordingly .
//the types are working as defined in reducer and the data is stored in initial States
//initialStates are in redux initialState folder...
const GETendpointActionTypes = {
  branch: GET_BRANCH_DATA_SUCCESS,
  superBranch: GET_SUPER_BRANCH_DATA_SUCCESS,
  course: GET_COURSE_DATA_SUCCESS,
  source: GET_SOURCE_DATA_SUCCESS,
  city: GET_CITY_DATA_SUCCESS,
  superCity: GET_SUPER_CITY_DATA_SUCCESS,
  template: GET_WHATSIMAGE_DATA_SUCCESS,
  contact: GET_CONTACT_DATA_SUCCESS,
  status: GET_STATUS_DATA_SUCCESS,
  user: GET_USER_DATA_SUCCESS,
  assignTo: GET_USER_DATA_SUCCESS,
  "": GET_ADMIN_DATA_SUCCESS,
  issue: GET_SUPPORT_DATA_SUCCESS,
  dashboardAdminsRevenue: GET_SUPER_ADMIN_REVENUE,
  dashboard: GET_SUPER_DASHBOARD_TILES,
  sidemenu: GET_SUPER_SIDEMENU,
  todo: GET_SUPER_TODO,
  proposal: GET_PROPOSAL_DATA,
  proposalGreeting: GET_PROPOSAL_GREETING_DATA,
  greetingCategory: GET_GREETING_CATEGORY_DATA,

  lead: GET_LEAD_DATA_SUCCESS,
  "dashboard/leads-count": GET_LEAD_COUNT_SUCCESS,
  "dashboard/analytics": GET_COURSE_ANALYTICS_SUCCESS,
  "dashboard/source": GET_SOURCE_ANALYTICS_SUCCESS,

  emailTemplate: GET_EMAIL_TEPLATES_SUCCESS,
  superEmailTemplate: GET_SUPER_EMAIL_TEMPLATES_SUCCESS,
  emailTemplateCategory: GET_EMAIL_TEMPLATE_CATOGORY_SUCCESS,
  superEmailTemplateCategory: GET_SUPER_EMAIL_TEMPLATE_CATOGORY_SUCCESS,
  "client-proposal/email-report": GET_EMAIL_CAMPAIGN_REPORT,

  whatsAppTemplate: GET_WHATSAPP_TEMPLATE_SUCCESS,
  smsTemplate: GET_SMS_TEMPLATE_SUCCESS,

  "demo-user": GET_DEMO_ENQUIRY_SUCCESS,
  addSuperUser: GET_SUPER_USER_DATA_SUCCESS,
  superGreetingCategoires: GET_SUPER_GREETING_CATEGORIES_SUCCESS,
  superProposalGreeting: GET_SUPER_PROPOSAL_GREETING_SUCCESS,
  "navbar-content": GET_NAVBAR_CONTENT_SUCCESS,
  "legal-content": GET_LEGAL_CONTENT_SUCCESS,
  "public/legal-content": GET_PUBLIC_LEGAL_CONTENT_SUCCESS,
  "contact-enquiry": GET_CONTACT_ENQUIRY_SUCCESS,
  "footer-content": GETFOOTERCONTENTSUCCESS,
  "proposal/summary/statistics": GET_PROPOSAL_SUMMARY_SUCCESS,
  proposalTerms: GET_PROPOSAL_TERMS_DATA,
  termsCategory: GET_TERMS_CATEGORY_DATA,
  superTermsCategories: GET_SUPER_TERMS_CATEGORIES_SUCCESS,
  superProposalTerms: GET_SUPER_PROPOSAL_TERMS_SUCCESS,
  "payment/search": GET_PAYMENT_DETAILS_SUCCESS,
  "lead-field-config": GET_LEAD_FIELD_CONFIG_SUCCESS,
  account: GET_ACCOUNT_DATA_SUCCESS,
  admission: GET_ADMISSION_DATA_SUCCESS,
};
//common function for getdata in array
//it took parameter as  endpoint only
export const getData = (endpoint) => async (dispatch) => {
  console.log(endpoint);
  const [endpointWithoutQuery, queryParameters] = endpoint.split("?");
  let successActionType = GETendpointActionTypes[endpointWithoutQuery];
  console.log(successActionType);
  dispatch({ type: GET_DATA_REQUEST });

  try {
    console.log("start");
    const token = Cookies.get("token");

    const res = await axios.get(`${BASE_URL}${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Pass the token in the headers
      },
    });

    console.log(res.data.Data);
    dispatch({
      type: successActionType,
      payload: res.data.Data,
      message: res.data.message,
      page: res.data.page,
    });

    return {
      data: res.data.Data,
      message: res.data.message,
      page: res.data.page,
    };
  } catch (error) {
    if (error.response?.status === 401) {
      Cookies.set("logoutMessage", error.response?.data?.message, {
        path: "/",
        secure: false,
      });

      dispatch({ type: POST_SIGN_OUT_SUCCESS });

      window.location.href = "/login";
    } else {
      toast({
        title: error.response?.data?.message || error.message,
        status: "error",
        duration: 3000,
        position: "top-right",
        isClosable: true,
      });
    }

    dispatch({ type: GET_DATA_FAILURE, payload: error.message });
  }
};

export const getDataSuperAdmin = (endpoint) => async (dispatch) => {
  const [endpointWithoutQuery, queryParameters] = endpoint.split("?");
  let successActionType = GETendpointActionTypes[endpointWithoutQuery];

  dispatch({ type: GET_DATA_REQUEST });

  try {
    const token = Cookies.get("token");

    const res = await axios.get(`${BASE_URL_SUPERADMIN}${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Pass the token in the headers
      },
    });

    dispatch({
      type: successActionType,
      payload: res.data.Data,
      page: res.data.page,
    });
    return res.data.Data;
  } catch (error) {
    dispatch({ type: GET_DATA_FAILURE, payload: error.message });
    console.log(error);
  }
};

//GET SINGLE DATA BY ID
//these are endpointGetSingleActionTypes for the Types of the redux
//if the endpoint is coming branch then it will trigger the TYPE e.g.  GET_SINGLE_BRANCH_DATA_SUCCESS,
//endpoint are coming  from the parameter of the function and its triggering the action accordingly .
//the types are working as defined in reducer and the data is stored in initial States
//initialStates are in redux initialState folder...
const endpointGetSingleActionTypes = {
  course: GET_SINGLE_COURSE_DATA_SUCCESS,
  branch: GET_SINGLE_BRANCH_DATA_SUCCESS,
  source: GET_SINGLE_SOURCE_DATA_SUCCESS,
  city: GET_SINGLE_CITY_DATA_SUCCESS,
  template: GET_SINGLE_WHATSIMAGE_DATA_SUCCESS,
  contact: GET_SINGLE_CONTACT_DATA_SUCCESS,
  status: GET_SINGLE_STATUS_DATA_SUCCESS,
  user: GET_SINGLE_USER_DATA_SUCCESS,
  adminUsers: GET_SINGLE_ADMIN_DATA_SUCCESS,
  issue: GET_SINGLE_SUPPORT_DATA_SUCCESS,
  adminProductRevenues: GET_SUPER_SINGLE_PARTICULAR_ADMIN_REVENUE,
  sidemenue: GET_SINGLE_SUPER_SIDEMENU,
  todo: GET_SINGLE_SUPER_TODO,
  proposal: GET_SINGLE_PROPOSAL,
  proposalGreeting: GET_SINGLE_PROPOSAL_GREETING,

  lead: GET_SINGLE_LEAD_DATA_SUCCESS,
  "demo-user": GET_SINLGE_DEMO_EMQUIRY_DATA_SUCCESS,
  "navbar-content": GET_SINGLE_NAVBAR_CONTENT_SUCCESS,
  "legal-content": GET_SINGLE_LEGAL_CONTENT_SUCCESS,
  "contact-enquiry": GET_SINGLE_CONTACT_ENQUIRY_SUCCESS,
  "footer-content": GETSINGLEFOOTERCONTENTSUCCESS,
  proposalTerms: GET_SINGLE_PROPOSAL_TERMS,
  admission: GET_SINGLE_ADMISSION_DATA_SUCCESS,
};

//common function for getdata by id
//it took parameter as id, endpoint
export const getDataById = (id, endpoint) => async (dispatch) => {
  console.log(id, endpoint, "ddd");
  let successGetActionType = endpointGetSingleActionTypes[endpoint];

  dispatch({ type: GET_SINGLE_DATA_REQUEST });
  try {
    const token = Cookies.get("token");

    const res = await axios.get(`${BASE_URL}${endpoint}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Pass the token in the headers
      },
    });
    dispatch({ type: successGetActionType, payload: res.data });
    console.log(res.data);

    return res.data;
  } catch (error) {
    dispatch({ type: GET_SINGLE_DATA_FAILURE, payload: error.message });
    console.log(error);
  }
};

export const getDataByIdSuperAdmin = (id, endpoint) => async (dispatch) => {
  let successGetActionType = endpointGetSingleActionTypes[endpoint];

  dispatch({ type: GET_SINGLE_DATA_REQUEST });
  try {
    const token = Cookies.get("token");

    const res = await axios.get(`${BASE_URL_SUPERADMIN}${endpoint}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Pass the token in the headers
      },
    });
    dispatch({ type: successGetActionType, payload: res.data });

    return res.data;
  } catch (error) {
    dispatch({ type: GET_SINGLE_DATA_FAILURE, payload: error.message });
    console.log(error);
  }
};

//DELETE DATA
//these are enpointActionTypes for the Types of the redux
//if the endpoint is coming branch then it will trigger the TYPE e.g.  DELETE_BRANCH_DATA_SUCCESS,
//endpoint are coming  from the parameter of the function and its triggering the action accordingly .
const endpointActionTypesDelete = {
  course: DELETE_COURSE_DATA_SUCCESS,
  branch: DELETE_BRANCH_DATA_SUCCESS,
  source: DELETE_SOURCE_DATA_SUCCESS,
  city: DELETE_CITY_DATA_SUCCESS,
  template: DELETE_WHATSIMAGE_DATA_SUCCESS,
  status: DELETE_STATUS_DATA_SUCCESS,
  user: DELETE_USER_DATA_SUCCESS,
  admin: DELETE_ADMIN_DATA_SUCCESS,
  lead: DELETE_LEAD_DATA_SUCCESS,
  sidemenu: DELETE_SUPER_SIDEMENU,
  proposalGreeting: DELETE_GREETING_SUCCESS,
  proposal: DELETE_PROPOSAL_SUCCESS,
  // "admins/todo": DELETE_SUPER_TODO,
  todo: DELETE_TODO_DATA,
  emailTemplate: DELETE_EMAIL_TEMPLATE_SUCCESS,
  whatsAppTemplate: DELETE_WHATSAPP_TEMPLATE_SUCCESS,
  smsTemplate: DELETE_SMS_TEMPLATE_SUCCESS,
  "navbar-content": DELETE_NAVBAR_CONTENT_SUCCESS,
  "legal-content": DELETE_LEGAL_CONTENT_SUCCESS,
  "contact-enquiry": DELETE_CONTACT_ENQUIRY_SUCCESS,
  "footer-content": DELETEFOOTERCONTENTSUCCESS,
  proposalTerms: DELETE_TERMS_SUCCESS,
  account: DELETE_ACCOUNT_DATA_SUCCESS,
  admission: DELETE_ADMISSION_DATA_SUCCESS,
};
//common function for deleting the data
//it took parameter as id, endpoint,toast

export const deleteData = (id, endpoint, toast) => async (dispatch) => {
  let successDeleteActionType = endpointActionTypesDelete[endpoint];

  dispatch({ type: DELETE_DATA_REQUEST });
  try {
    const token = Cookies.get("token");

    const res = await axios.delete(`${BASE_URL}${endpoint}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`, // Pass the token in the headers
      },
    });
    if (res.data) {
      dispatch({ type: successDeleteActionType, payload: res.data.Data });
      toast({
        title: `${res.data.message}`,
        status: "success",
        position: "top-right",
        isClosable: true,
      });
      return res.data.Data;
    } else {
      // Handle the case where res.data is undefined
      throw new Error("Invalid response data");
    }
  } catch (error) {
    dispatch({ type: DELETE_DATA_FAILURE, payload: error.message });
    toast({
      title: `${error.response?.data?.message || error.message}`,
      status: "error",
      position: "top-right",
      isClosable: true,
    });
    console.log(error);
  }
};

export const deleteDataSuperAdmin =
  (id, endpoint, toast) => async (dispatch) => {
    let successDeleteActionType = endpointActionTypesDelete[endpoint];

    dispatch({ type: DELETE_DATA_REQUEST });
    try {
      const token = Cookies.get("token");

      const res = await axios.delete(
        `${BASE_URL_SUPERADMIN}${endpoint}/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the headers
          },
        },
      );
      if (res.data) {
        dispatch({ type: successDeleteActionType, payload: res.data.Data });
        toast({
          title: `${res.data.message}`,
          status: "success",
          position: "top-right",
          isClosable: true,
        });
        return res.data.Data;
      } else {
        // Handle the case where res.data is undefined
        throw new Error("Invalid response data");
      }
    } catch (error) {
      dispatch({ type: DELETE_DATA_FAILURE, payload: error.message });
      toast({
        title: `${error.response?.data?.message || error.message}`,
        status: "error",
        position: "top-right",
        isClosable: true,
      });
      console.log(error);
    }
  };

//UPDATE DATA
//these are enpointActionTypes for the Types of the redux
//if the endpoint is coming course then it will trigger the TYPE e.g. UPDATE_COURSE_DATA_SUCCESS.
//endpoint are coming  from the parameter of the function and its triggering the action accordingly .
const endpointActionTypes = {
  course: UPDATE_COURSE_DATA_SUCCESS,
  branch: UPDATE_BRANCH_DATA_SUCCESS,
  superBranch: UPDATE_SUPER_BRANCH_DATA_SUCCESS,
  source: UPDATE_SOURCE_DATA_SUCCESS,
  city: UPDATE_CITY_DATA_SUCCESS,
  superCity: UPDATE_SUPER_CITY_DATA_SUCCESS,
  template: UPDATE_WHATSIMAGE_DATA_SUCCESS,
  status: UPDATE_STATUS_DATA_SUCCESS,
  user: UPDATE_USER_DATA_SUCCESS,
  adminUsers: UPDATE_ADMIN_DATA_SUCCESS,
  lead: UPDATE_LEAD_DATA_SUCCESS,
  sidemenu: UPDATE_SUPER_SIDEMENU,
  issue: UPDATE_SUPPORT_DATA_SUCCESS,

  todo: UPDATE_SUPER_TODO,
  proposal: UPDATE_PROPOSAL_DATA,
  proposalGreeting: UPDATE_PROPOSAL_GREETING_DATA,

  emailTemplate: UPDATE_EMAIL_TEMPLATE_DATA,
  superEmailTemplate: UPDATE_SUPER_EMAIL_TEMPLATE_DATA,
  whatsAppTemplate: UPDATE_WHATSAPP_TEMPLATE_DATA,
  smsTemplate: UPDATE_SMS_TEMPLATE_DATA,
  "demo-user": UPDATE_DEMO_ENQUIRY_DATA_SUCCESS,
  addSuperUser: UPDATE_SUPER_USER_DATA_SUCCESS,

  superProposalGreeting: UPDATE_SUPER_PROPOSAL_GREETING_SUCCESS,
  "navbar-content": UPDATE_NAVBAR_CONTENT_SUCCESS,
  "legal-content": UPDATE_LEGAL_CONTENT_SUCCESS,
  "contact-enquiry": UPDATE_CONTACT_ENQUIRY_SUCCESS,
  "footer-content": UPDATEFOOTERCONTENTSUCCESS,
  proposalTerms: UPDATE_PROPOSAL_TERMS_DATA,
  superProposalTerms: UPDATE_SUPER_PROPOSAL_TERMS_SUCCESS,
  "proposal/mark-as-sent": MARK_PROPOSAL_AS_SENT_SUCCESS,
  "proposal/cancel": CANCEL_PROPOSAL_SUCCESS,
  "proposal/send-manual-reminder": SEND_PAYMENT_REMAINDER_MAIL,
  "lead/summary/statistics": GET_LEAD_SUMMARY_SUCCESS,
  "proposal/update-payment-mode": UPDATE_PROPOSAL_PAYMENT_MODE_SUCCESS,
  "proposal/update-manual-payment": UPDATE_MANUAL_PAYMENT_SUCCESS,
  account: UPDATE_ACCOUNT_DATA_SUCCESS,
  admission: UPDATE_ADMISSION_DATA_SUCCESS,
  "admission/send-reminder": SEND_ADMISSION_PAYMENT_REMAINDER_MAIL,
  "admission/update-payment-mode": UPDATE_ADMISSION_PAYMENT_MODE_SUCCESS,
  "admission/update-manual-payment": UPDATE_MANUAL_PAYMENT_SUCCESS,
};

//common function for updating the data
//it took parameter as id endpoint formdata and navigation route and toast
export const updateData =
  (id, endpoint, formData, navigate, toast) => async (dispatch) => {
    console.log(id, formData, "id form actions");
    console.log(endpoint, "endpoint");
    const successUpdateActionType = endpointActionTypes[endpoint];

    if (!successUpdateActionType) {
      console.log(`No success action type defined for endpoint: ${endpoint}`);
      return;
    }
    dispatch({ type: UPDATE_DATA_REQUEST });
    try {
      const token = Cookies.get("token");

      const res = await axios.put(`${BASE_URL}${endpoint}/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`, // Pass the token in the headers
        },
      });
      console.log(res.data.message, "alert");
      await dispatch({ type: successUpdateActionType, payload: res.data });
      toast({
        title: `${res.data.message}`,
        status: "success",
        position: "top-right",
        isClosable: true,
      });
      if (endpoint in endpointRoutes) {
        navigate(endpointRoutes[endpoint]); // Navigate based on the endpoint route
      }
      return res.data;
    } catch (error) {
      dispatch({ type: UPDATE_DATA_FAILURE, payload: error.message });
      console.log(error);
      toast({
        title: error.response?.data?.message || "Something went wrong..",
        status: "error",
        position: "top-right",
        isClosable: true,
      });
    }
  };

export const updateDataSuperAdmin =
  (id, endpoint, formData, navigate, toast) => async (dispatch) => {
    console.log(id, formData, "id form actions");
    const successUpdateActionType = endpointActionTypes[endpoint];

    if (!successUpdateActionType) {
      console.log(`No success action type defined for endpoint: ${endpoint}`);
      return;
    }
    dispatch({ type: UPDATE_DATA_REQUEST });
    try {
      const token = Cookies.get("token");

      const res = await axios.put(
        `${BASE_URL_SUPERADMIN}${endpoint}/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the headers
          },
        },
      );
      dispatch({ type: successUpdateActionType, payload: res.data });
      console.log(res.data.message, "alert");
      toast({
        title: `${res.data.message}`,
        status: "success",
        position: "top-right",
        isClosable: true,
      });
      if (endpoint in endpointRoutes) {
        navigate(endpointRoutes[endpoint]); // Navigate based on the endpoint route
      }
      return res.data;
    } catch (error) {
      dispatch({ type: UPDATE_DATA_FAILURE, payload: error.message });
      console.log(error);
      toast({
        title: error.response?.data?.message || "Something went wrong..",
        status: "error",
        position: "top-right",
        isClosable: true,
      });
    }
  };
